import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Paper, FormControl, InputLabel, Select, MenuItem,
} from '@material-ui/core';

import Actions from '../actions';

class SelectPlan extends Component {
  constructor(props) {
    super(props);
    this.state = {
      plan: '',
    };
  }

  componentDidMount() {
    this.props.getPlans();
  }

    handleChange = (event) => {
      this.setState({ plan: event.target.value },
        // eslint-disable-next-line consistent-return
        () => {
          if (this.state.plan) return this.props.callBack(this.state.plan);
        });
    };

    render() {
      const { plans } = this.props;
      return (
        <Paper style={{ width: '500px', padding: '50px' }}>
          <h3 style={{ marginTop: 0 }}>Select Plan</h3>
          <FormControl fullWidth style={{ marginTop: '15px' }}>
            <InputLabel id="demo-simple-select-filled-label">Plan</InputLabel>
            <Select
              labelId="demo-simple-select-filled-label"
              id="demo-simple-select-filled"
              value={this.state.plan}
              onChange={this.handleChange}
              style={{ textAlign: 'left' }}
            >
              <MenuItem value="">
                <em>None</em>
              </MenuItem>
              {
                            plans && plans.map((plan) => { return (<MenuItem key={plan._id} value={plan}>{plan.name}</MenuItem>); })
                        }
            </Select>
          </FormControl>
        </Paper>
      );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

function mapStateToProps(state) {
  return {
    plans: state.plans.data,
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SelectPlan));
